import { createContext, useContext, useState } from "react";
type TabsProviderState = {
  active: string;
  setActive: (id: string) => void;
};

const TabsProviderContext: TabsProviderState = {
  active: "",
  setActive: () => {},
};

export const ViewContext =
  createContext<TabsProviderState>(TabsProviderContext);

type ViewProviderProps = {
  children: React.ReactNode;
  id: string;
};

export const TabsProvider = ({ children, id }: ViewProviderProps) => {
  const [active, setActive] = useState<string>(id);

  return (
    <ViewContext.Provider
      value={{
        active,
        setActive,
      }}
    >
      {children}
    </ViewContext.Provider>
  );
};

export const useActive = () => {
  const { active, setActive } = useContext(ViewContext);
  return { active, setActive };
};
